// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { celoAlfajores as _celoAlfajores } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the celoAlfajores chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 44787
 * Chain Name: Alfajores
 * Default Block Explorer: https://explorer.celo.org/alfajores
 * Default RPC URL: https://alfajores-forno.celo-testnet.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { celoAlfajores } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: celoAlfajores,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const celoAlfajores = createCommon({
	..._celoAlfajores,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
